import moment from 'moment';
import 'moment/dist/locale/pt-br';

moment.locale('pt-br');
window.moment = moment;
